export default __webpack_public_path__ + "static/media/rice08.6279d936.png";